/**
 * useAuth — convenience hook for consuming AuthContext.
 *
 * Exposes: user, organization, role, isAuthenticated, isLoading,
 *          login(), logout(), hasPermission()
 *
 * Import this hook in components instead of useAuthContext directly.
 */
import { useAuthContext } from '@/contexts/AuthContext'

export function useAuth() {
  return useAuthContext()
}
